const initialState = {
  localidadValues: [],
  entityValues: [],
  requestingEntity: false,
  requestingLocalidad: false,
  entitySuggestion: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_A_ENTITY':
      return {
        ...state,
        requestingEntity: true
      }
    case 'RECEIVE_A_ENTITY':
      state.entityValues[action.entity] = action.values
      return {
        ...state,
        requestingEntity: false
      }
    case 'RESET_ENTITY':
      return {
        ...state,
        entityValues: []
      }
    case 'REQUEST_A_LOCALIDAD':
      return {
        ...state,
        requestingLocalidad: true
      }
    case 'RECEIVE_A_LOCALIDAD':
      return {
        ...state,
        localidadValues: action.values,
        requestingLocalidad: false
      }
    default:
      return state
  }
}
